import script from "./PageEditorVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./PageEditorVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./PageEditorVideoPlayer.vue?vue&type=style&index=0&id=da49031e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da49031e"]])

export default __exports__